// ============================================================================
// EndosoCambiosMulti — captura VARIOS cambios en un mismo endoso.
// Cada cambio = { tipo_endoso_id, cambios }. Reutiliza EndosoCambioForm para el
// detalle según el `target` del tipo elegido. Se usa en la solicitud de endoso,
// al facturar y en el endoso interno.
// value: array de cambios; onChange(nextArray).
// ============================================================================
import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import EndosoCambioForm from './EndosoCambioForm';
import { targetAplica } from '../db/endosos';

export default function EndosoCambiosMulti({ tipos, ramoId, polizaId, value, onChange }) {
  const list = (value && value.length) ? value : [{ tipo_endoso_id: '', cambios: null }];
  const tiposDelRamo = (tipos || []).filter(t => t.ramo_id == null || String(t.ramo_id) === String(ramoId));

  const updateChange = (idx, patch) => onChange(list.map((x, i) => i === idx ? { ...x, ...patch } : x));
  const addChange = () => onChange([...list, { tipo_endoso_id: '', cambios: null }]);
  const removeChange = (idx) => onChange(list.length > 1 ? list.filter((_, i) => i !== idx) : list);

  return (
    <div>
      {list.map((ch, idx) => {
        const tipoSel = (tipos || []).find(t => String(t.id) === String(ch.tipo_endoso_id));
        const target = tipoSel?.target;
        return (
          <div key={idx} style={{
            border: '1px solid rgba(245,158,11,0.25)', borderRadius: 8,
            padding: '12px 14px', marginBottom: 10, background: 'rgba(245,158,11,0.05)',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-warning)' }}>Cambio {idx + 1}</div>
              {list.length > 1 && (
                <button type="button" className="btn btn-icon btn-danger btn-sm" onClick={() => removeChange(idx)} title="Quitar este cambio">
                  <Trash2 size={13} />
                </button>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Tipo de cambio *</label>
              <select className="form-select" value={ch.tipo_endoso_id || ''}
                onChange={e => updateChange(idx, { tipo_endoso_id: e.target.value, cambios: null })}>
                <option value="">Seleccionar tipo...</option>
                {tiposDelRamo.map(t => (
                  <option key={t.id} value={t.id}>
                    {t.nombre}{t.comportamiento === 'cancelacion' ? ' (cancelación)' : t.comportamiento === 'prorroga' ? ' (prórroga)' : ''}
                  </option>
                ))}
              </select>
            </div>
            {target && targetAplica(target) && (
              <div style={{ marginTop: 10 }}>
                <EndosoCambioForm target={target} polizaId={polizaId}
                  value={ch.cambios || {}} onChange={c => updateChange(idx, { cambios: c })} />
              </div>
            )}
          </div>
        );
      })}
      <button type="button" className="btn btn-secondary btn-sm" onClick={addChange}>
        <Plus size={13} /> Agregar otro cambio
      </button>
    </div>
  );
}
